import { render, staticRenderFns } from "./seniorTwo.vue?vue&type=template&id=02af92ba&scoped=true"
import script from "./seniorTwo.vue?vue&type=script&lang=js"
export * from "./seniorTwo.vue?vue&type=script&lang=js"
import style0 from "./seniorTwo.vue?vue&type=style&index=0&id=02af92ba&prod&scoped=true&lang=less"
import style1 from "./seniorTwo.vue?vue&type=style&index=1&id=02af92ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02af92ba",
  null
  
)

export default component.exports